<template>
  <a-modal
    wrap-class-name="user-leave-modal"
    :visible="true"
    :closable="false"
    :mask-closable="false"
  >
    <div style="text-align: center">
      <img style="width: 60%" src="~@/assets/images/account-locked.png">
      <h2 style="margin-top: 30px">{{ $t("common_text_055") }}</h2>
      <div style="color: rgba(0, 0, 0, 0.6);">{{ $t("common_text_056") }}</div>
    </div>
    <template #footer>
      <div style="text-align: center; padding-top: 34px">
        <a-button
          type="primary"
          shape="round"
          style="min-width: 120px; background: #BA8438; height: 39px;border-color: #BA8438;"
          @click="linkBack"
        >{{ $t("common_text_057") }}</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { inject } from 'vue'
export default {
  name: 'UserLeave',
  setup() {
    const router = useRouter()
    const store = useStore()
    const themeData = inject('$themeData')
    const linkBack = () => {
      const userInfo = localStorage.getItem('userInfo')
      if (userInfo) store.commit('updateUserInfo', JSON.parse(userInfo))
      router.back()
    }
    return {
      themeData,
      linkBack
    }
  }
}
</script>

<style lang="less">
.user-leave-modal {
  background: #FFFCF5;
  .ant-modal-header,
  .ant-modal-footer {
    border: none;
  }
  .ant-modal{
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    .ant-modal-content{
      background: #FFFCF5;
    }
  }
}
</style>
